import auth from './auth';
import learning from './learning';
import ksord from './ksord';
import vipapi from './vipapi';

const service = {
  auth,
  learning,
  ksord,
  vipapi
};

export default (info, inject) => {
  inject('service', service);
};
